import { Image } from 'foundations-components/transitional/components/Image';
import imageUrls from '../images/imageUrls';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const getAcademyLogoConfig = isMobile => {
  const url = isMobile ? null : imageUrls.academyLogo;
  return {
    url,
    altText: 'HubSpot Academy'
  };
};
export const AcademyLogo = () => {
  const {
    isMobile
  } = useResponsiveness();
  const {
    url,
    altText
  } = getAcademyLogoConfig(isMobile);
  if (isMobile) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Image, {
      alt: altText,
      display: "inline-block",
      inlineSize: "208px",
      responsive: false,
      src: url
    })
  });
};